import React, { useEffect, useState } from 'react';
import {
  Fade, Grid,
} from '@mui/material';
import * as Sentry from '@sentry/react';
import useStyles from '../styles';
import type { Partner, PartnerEntityConfig } from '../types';
import bancameLogoWhite from /* webpackPreload: true */ '../../../assets/bancame_logo_white.svg';
import PlrDesktopProjectPanel from '../../../feature/preloan/v3-redesign/PlrProjectHero';
import partnerPrimary from '../../../feature/preloan/v3-redesign/partnerColor';
import { companyOverline, projectEntityLabel, resolvePlrHeroImage } from '../../../feature/preloan/v3-redesign/heroVariant';

type LeadFormRightGridProps = {
    partner: Partner,
    xs?: number|false,
    lg?: number|false,
    hideHero: boolean,
    projectCard?: boolean,
}

const defaultProps = {
  xs: false,
  lg: 7,
  projectCard: false,
};

export default function LeadFormRightGridRedesign(props: LeadFormRightGridProps) {
  const {
    partner, xs, lg, hideHero, projectCard = false,
  } = props;
  const backgroundImage = hideHero ? undefined : partner.config.styles?.backgroundImage;
  const classes = useStyles();
  const [backgroundStyles, setBackgroundStyles] = useState<React.CSSProperties>({});
  const getClassNameRightGrid = (
    partnerConfiguration: PartnerEntityConfig,
    partnerName: string,
  ) => {
    if (hideHero || !partnerConfiguration?.styles?.backgroundImage || partnerName === 'Banca.Me') {
      return classes.rightGrid;
    }

    return classes.rightGridPartner;
  };

  const loadImage = (src: string): Promise<HTMLImageElement> => new Promise((resolve, reject) => {
    const img = new Image();
    img.src = src;
    img.onload = () => resolve(img);
    img.onerror = reject;
  });

  const getCustomImageRightGrid = async () => {
    const imageUrl = backgroundImage;
    try {
      if (imageUrl) {
        const img = await loadImage(imageUrl);
        const styles: React.CSSProperties = {
          backgroundImage: `url('${imageUrl}')`,
          backgroundSize: img.width > img.height ? 'contain' : 'cover',
        };
        setBackgroundStyles(styles);
      }
    } catch (error) {
      Sentry.setContext('Partners background image load error', {
        error,
      });
    }
  };

  useEffect(() => {
    getCustomImageRightGrid();
  }, [backgroundImage]);

  if (projectCard) {
    return (
      <Fade in {...({ timeout: 800 })}>
        <Grid
          item
          xs={false}
          lg={lg}
          sx={{
            display: { xs: 'none', lg: 'flex' },
            alignItems: 'center',
            backgroundColor: '#fff',
            p: 3,
          }}
        >
          <PlrDesktopProjectPanel
            image={resolvePlrHeroImage(partner.config.styles?.backgroundImage)}
            projectName={projectEntityLabel(partner.partnerEntityName, partner.partnerName)}
            entityName={companyOverline(partner.partnerEntityName, partner.partnerName)}
            primary={partnerPrimary(partner.config.styles?.primaryColor)}
            accent={partner.config.styles?.secondaryColor || '#755DDF'}
          />
        </Grid>
      </Fade>
    );
  }

  return (
    <Fade
      in
      {...({ timeout: 2500 })}
    >
      <Grid
        item
        xs={xs}
        lg={lg}
        className={getClassNameRightGrid(
          partner.config,
          partner.partnerName,
        )}
        style={backgroundStyles}
      >
        {!backgroundImage && (
        <div style={{
          display: 'flex',
          width: '100%',
          height: '100%',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          transform: 'rotateX(180deg)',
        }}
        >

          <img src={bancameLogoWhite} width="500px" alt="BancaMeLogo" aria-hidden />
        </div>
        )}
      </Grid>
    </Fade>
  );
}

LeadFormRightGridRedesign.defaultProps = defaultProps;
